import { Location } from '@angular/common';
import { Component, ViewChild, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { GenericDialogComponent } from 'src/app/modules/shared/generic-dialog/generic-dialog.component';
import { CatalogDialogComponent } from '../catalog-dialog/catalog-dialog.component';
import { ApiEstimativaService } from 'src/app/modules/shared/services/api-estimativa.service';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { ProjectsService } from 'src/app/modules/shared/services/projects.service';
import { LanguageService } from 'src/app/modules/shared/services/language.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatTable } from '@angular/material/table';
import { ActionItem } from 'src/app/models/ActionItem';
import { SelectionModel } from '@angular/cdk/collections';
import { FormBuilder, Validators } from '@angular/forms';
import { TechnologiesManagementService } from 'src/app/modules/shared/services/technologiesManagement.service';
import { TecnologiasService } from 'src/app/modules/shared/services/tecnologias.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Review } from 'src/app/models/Review';
import { CatalogService } from 'src/app/modules/shared/services/catalog.service';
import { catchError, delay, retryWhen, scan } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { getEstimationErrorMessages } from 'src/app/constants/estimation-error-messages';
import {
  hasAiGeneratedMacros,
  hasAiGeneratedSubTasks,
  isAiGeneratedItem
} from '../ai-estimate.utils';
import { InfoBarWithStatusService } from 'src/app/modules/shared/services/info-bar-with-status.service';
import { ProfileService } from 'src/app/modules/shared/services/profile.service';
import { Profile } from 'src/app/models/Profile';
import { EstimationState } from 'src/app/models/EstimationState';
import { NotificationsService } from 'src/app/modules/shared/services/notifications.service';


@Component({
  standalone: false,
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.css']
})

export class ActivityComponent implements OnInit {

  @ViewChild('table', { static: true }) table!: MatTable<any>;

  catalogo: any = [];
  variables: any;
  arr1: any = [];

  columns: any[] = ['position', 'checkbox', 'action', 'activity', 'complexityLevel', 'itemCount', 'complexity', 'productivityTool', 'profile', 'aiGenerated', 'actions'];
  columnsComplex: any[] = ['position', 'checkbox', 'epic', 'userStory', 'action', 'activity', 'complexityLevel', 'itemCount', 'complexity', 'productivityTool', 'profile', 'aiGenerated', 'actions'];
  columnsTshirt: any[] = ['position', 'checkbox', 'epic', 'userStory', 'action', 'activity', 'tshirtScale', 'itemCount', 'complexDays', 'complexity', 'productivityTool', 'profile', 'aiGenerated', 'actions'];
  //columns: any[] = ['position','action', 'activity', 'complexityLevel', 'itemCount', 'complexity', 'scr', 'actions'];
  dragDisabled = true;
  selection = new SelectionModel(true);
  selectedActivities: boolean = false;
  invalidInput: boolean = false;
  errorMessage = '';
  tools: any = [];
  formGroup: any;
  initialEstimate: any = [];

  // Send list of acitivties and phase number to parent.
  @Output() sectionEvent = new EventEmitter<number>();
  @Output() atividadesEvent = new EventEmitter<any>();
  @Output() estimateEvent = new EventEmitter<any>();

  // Estimate, technology, atividades and isUpdate is passed from parent.
  @Input()
  estimate: any;
  @Input()
  technology: any;
  @Input()
  originalProject: any;
  @Input()
  atividades: any = [];
  @Input()
  isUpdate: any;
  @Input()
  modifiedSubTasks: any = [];
  @Input()
  idEstimate: any;

  @Input()
  subTasksAiWarning: boolean = false;

  isLoadingCatalog: boolean = true;
  errorDetected: boolean = false;
  errorText: string = '';
  catalogTasks: any = [];
  catalogSubTasks: any = [];

  errorMessages: any;
  profiles: Profile[] = [];;

  constructor(
    private tecnologiasService: TecnologiasService,
    private dataService: DataService,
    private dialog: MatDialog,
    private estimativaService: ApiEstimativaService,
    private projectService: ProjectsService,
    private router: Router,
    private location: Location,
    private _snackBar: MatSnackBar,
    private infoBar: InfoBarWithStatusService,
    private languageService: LanguageService,
    private _formBuilder: FormBuilder,
    private TechnologiesManagementService: TechnologiesManagementService,
    private catalogService: CatalogService,
    private notificationsService: NotificationsService,
    private profileService: ProfileService
  ) { }

  public estimationState = EstimationState;

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });
    this.getCatalogById(this.estimate.catalog);

    this.profileService.getAllProfiles().subscribe(
      (profiles: Profile[]) => this.profiles = profiles,
      (err: any) => console.error('Error loading profiles', err)
    );

    if (!this.atividades) this.atividades = [];
    this.catalogService.getTechnologyFromCatalogId(this.estimate.catalog).subscribe((result: any) => {

      if (result) {
        this.tools = result.tools;

      }
      this.tools.push({ 'name': '', 'productivity': '' })

    })

    this.formGroup = this._formBuilder.group({
      toolCtrl: [Validators.required],
    });

    this.errorMessages = getEstimationErrorMessages(this.variables);
    this.initialEstimate = this.dataService.getEstimate();
  }

  hasAiGeneratedItems(): boolean {
    return hasAiGeneratedSubTasks(this.atividades);
  }

  isModifiedSubTaskRow(activity: any): boolean {
    if (!activity || !Array.isArray(this.modifiedSubTasks) || this.modifiedSubTasks.length === 0) {
      return false;
    }

    const activityTask = (activity.task || '').trim().toLowerCase();
    const activitySubTask = (activity.subTask || '').trim().toLowerCase();

    const retCheck =  this.modifiedSubTasks.some((item: any) => {
      const modifiedTask = (item?.task || '').trim().toLowerCase();
      const modifiedSubTask = (item?.subTask || '').trim().toLowerCase();
      return modifiedTask === activityTask && modifiedSubTask === activitySubTask;
    });

    //console.log('Checking if activity is modified:', { activityTask, activitySubTask, retCheck });

    return retCheck
  }

  getCatalogById(catalogId: string) {
    this.isLoadingCatalog = true;

    this.catalogService.getCatalogById(catalogId).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error;
            }
            return retryCount + 1;
          }, 0),
          delay(2500)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any) => {
        try {
          this.catalogTasks = data.tasks;
          this.catalogSubTasks = data.subTasks;

          if (this.isUpdate) {
            this.atividades = this.estimate.subTasks;
          }
        } catch (err) {
          console.error('Error:', err);

          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.catalogTasks && !this.errorDetected) {
          this.isLoadingCatalog = false;
        }
      }
    });
  }

  isAnyCheckboxChecked(): boolean {
    return this.selection.hasValue();
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.selection.selected.length > 0) {
      this.selectedActivities = true;
    }
    else {
      this.selectedActivities = false;
    }
    const numSelected = this.selection.selected.length;
    const numRows = this.atividades.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.atividades.forEach((row: any) => this.selection.select(row));
  }

  addToolToActivities() {
    if (this.formGroup.value.toolCtrl.name == '') {
      (this.selection.selected).forEach((activity: any) => {
        activity.tool = null;
      })
    }
    else {
      (this.selection.selected).forEach((activity: any) => {
        activity.tool = this.formGroup.value.toolCtrl;
      })
    }
  }

  back() {
    this.atividadesEvent.emit(this.atividades);
    this.estimateEvent.emit(this.estimate);
  }

  dropTable(event: CdkDragDrop<any[]>): void {
    this.dragDisabled = true;
    const previousIndex = this.atividades.findIndex((d: any) => d === event.item.data);
    moveItemInArray(this.atividades, event.previousIndex, event.currentIndex);
    this.table.renderRows();
  }

  private clearAiData() {
    this.dataService.clearAiGeneratedMacros();
    this.dataService.clearAiGeneratedActionItems();
    this.dataService.clearShowAiMacroWarning();
    this.dataService.clearAiModifieddActionItems();
  }

  saveEstimate() {
    let hasTool;
    // sincronizar siempre las tareas visibles con la estimación antes de validar
    this.estimate.subTasks = this.atividades || [];

    const hasAiActions = hasAiGeneratedSubTasks(this.estimate.subTasks);
    const hasAiMacros = hasAiGeneratedMacros(this.estimate.macroActivities);

    const hasTasks = this.estimate.subTasks.length > 0;
    let dialogMessage = hasTasks ? this.variables.howToSaveEstimate : this.variables.howToSaveOnlyAsOngoing;

    const algumTemTool = this.estimate.subTasks.some((item: any) => item.tool !== null);
    if (algumTemTool) {
      hasTool = true;
    } else {
      hasTool = false;
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: dialogMessage,
        needJustification: !hasTool,
        hasTasks: hasTasks,
        hasAiItems: hasAiMacros || hasAiActions
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        //change aiGenerated attribute to false
        (this.estimate.macroActivities || []).forEach((macro: any) => {
          (macro.macroActivities || []).forEach((ma: any) => { ma.aiGenerated = false; });
        });
        (this.estimate.subTasks || []).forEach((st: any) => { st.aiGenerated = false; }); 

        if (result.isComplete == false) {
          this.estimate.state = EstimationState.INCOMPLETE;
          this.estimate.noToolsJustification = '';
          // Draft: clear profileSnapshots so result view uses live profile costs
          this.estimate.profileSnapshots = [];
        }
        else if (result.isComplete == true) {
          this.estimate.state = EstimationState.COMPLETE;
          this.estimate.noToolsJustification = result.justification || '';

          // Complete: freeze profile costs as snapshots
          const allProfileIds = new Set<string>();
          (this.estimate.configurations || []).forEach((c: any) => { if (c.profileId) allProfileIds.add(c.profileId); });
          (this.estimate.parameters || []).forEach((p: any) => { if (p.profileId) allProfileIds.add(p.profileId); });
          (this.estimate.macroActivities || []).forEach((macro: any) => {
            (macro.macroActivities || []).forEach((ma: any) => { if (ma.profileId) allProfileIds.add(ma.profileId); });
          });
          (this.estimate.subTasks || []).forEach((st: any) => { if (st.profileId) allProfileIds.add(st.profileId); });

          this.estimate.profileSnapshots = Array.from(allProfileIds)
            .map(pid => {
              const profile = this.profiles.find(p => p.id === pid);
              return profile ? { profileId: profile.id, profileName: profile.name, costPerHour: profile.costPerHour || 0 } : null;
            })
            .filter((s: any) => s !== null);
        }

        if (this.isUpdate) {
          // Create clean DTO with proper numeric types
          const estimateDTO = {
            id: this.estimate.id,
            idEstimate: this.estimate.idEstimate,
            name: this.estimate.name,
            criticality: {
              complexity1: parseFloat(this.estimate.criticality.complexity1),
              complexity2: parseFloat(this.estimate.criticality.complexity2)
            },
            project: typeof this.estimate.project === 'string' ? this.estimate.project : this.estimate.project?.id,
            associatedName: this.estimate.associatedName,
            catalog: typeof this.estimate.catalog === 'string' ? this.estimate.catalog : this.estimate.catalog?.id,
            projectMetodology: this.estimate.projectMetodology,
            estimateMode: this.estimate.estimateMode,
            projectType: {
              name: this.estimate.projectType.name,
              risk: parseFloat(this.estimate.projectType.risk)
            },
            configurations: this.estimate.configurations?.map((c: any) => ({
              name: c.name,
              complexity: parseFloat(c.complexity),
              profileId: c.profileId
            })),
            parameters: this.estimate.parameters?.map((p: any) => ({
              name: p.name,
              complexity: parseFloat(p.complexity),
              profileId: p.profileId
            })),
            macroActivities: this.estimate.macroActivities?.map((macro: any) => ({
              metodology: macro.metodology,
              macroActivities: macro.macroActivities?.map((ma: any) => ({
                name: ma.name,
                effort: parseFloat(ma.effort),
                profileId: ma.profileId,
                maxHours: ma.maxHours ? parseFloat(ma.maxHours) : null,
                aiGenerated: false
              }))
            })),
            subTasks: this.estimate.subTasks?.map((st: any) => ({
              ...st,
              complexity: st.complexity ? parseFloat(st.complexity) : st.complexity,
              tshirtScaleEffort: st.tshirtScaleEffort ? parseFloat(st.tshirtScaleEffort) : st.tshirtScaleEffort
            })),
            state: this.estimate.state,
            noToolsJustification: this.estimate.noToolsJustification,
            profileSnapshots: this.estimate.profileSnapshots || []
          };
          estimateDTO.subTasks = estimateDTO.subTasks.map((st:any) => { st.aiGenerated = false; return st; })
          this.estimativaService.updateEstimate(this.estimate.id, estimateDTO).subscribe((data: any) => {
            if (data.success) {
              
              //just to be sure that all ai references are removed from the form and local storage, in case some slipped through the DTO transformation
              this.removeALLAiReferences();

              if (this.estimate.state === this.estimationState.COMPLETE) {
                this.notificationsService.refreshUnreadCountNow().subscribe();
                const source = this.dataService.getEstimativaNavigationContext() as { origin?: string } | null;
                if (source?.origin === "resultPage") {
                  this.router.navigate(['estimativa/resultado']);
                }
                else if (source?.origin === "combinedResultPage" || source?.origin === "projectPage") {
                  this.router.navigate(['/projecto']);
                } 
                else {
                  this.router.navigate(['/dashboard']);
                }
                
                this.dataService.clearEstimativaNavigationContext();
              }
              else
                this.router.navigate(['/dashboard']);
            }
            else {
              console.log("ERRO", data.message);
            }
          })
        }
        else {
          // Create clean DTO with proper numeric types
          const estimateDTO = {
            name: this.estimate.name,
            criticality: {
              complexity1: parseFloat(this.estimate.criticality.complexity1),
              complexity2: parseFloat(this.estimate.criticality.complexity2)
            },
            project: typeof this.estimate.project === 'string' ? this.estimate.project : this.estimate.project?.id,
            catalog: typeof this.estimate.catalog === 'string' ? this.estimate.catalog : this.estimate.catalog?.id,
            projectMetodology: this.estimate.projectMetodology,
            estimateMode: this.estimate.estimateMode,
            projectType: {
              name: this.estimate.projectType.name,
              risk: parseFloat(this.estimate.projectType.risk)
            },
            configurations: this.estimate.configurations?.map((c: any) => ({
              name: c.name,
              complexity: parseFloat(c.complexity),
              profileId: c.profileId
            })),
            parameters: this.estimate.parameters?.map((p: any) => ({
              name: p.name,
              complexity: parseFloat(p.complexity),
              profileId: p.profileId
            })),
            macroActivities: this.estimate.macroActivities?.map((macro: any) => ({
              metodology: macro.metodology,
              macroActivities: macro.macroActivities?.map((ma: any) => ({
                name: ma.name,
                effort: parseFloat(ma.effort),
                profileId: ma.profileId,
                maxHours: ma.maxHours ? parseFloat(ma.maxHours) : null,
                aiGenerated: ma.aiGenerated || false
              }))
            })),
            subTasks: this.estimate.subTasks?.map((st: any) => ({
              ...st,
              complexity: st.complexity ? parseFloat(st.complexity) : st.complexity,
              tshirtScaleEffort: st.tshirtScaleEffort ? parseFloat(st.tshirtScaleEffort) : st.tshirtScaleEffort
            })),
            state: this.estimate.state,
            noToolsJustification: this.estimate.noToolsJustification,
            profileSnapshots: this.estimate.profileSnapshots || []
          };
          this.estimativaService.saveEstimate(estimateDTO).subscribe((data: any) => {
            if (data.success) {
              if (this.estimate.state === this.estimationState.COMPLETE) {
                this.notificationsService.refreshUnreadCountNow().subscribe();
                const source = this.dataService.getEstimativaNavigationContext() as { origin?: string } | null;
                if (source?.origin === "resultPage") {
                  this.router.navigate(['estimativa/resultado']);
                } 
                else if (source?.origin === "combinedResultPage" || source?.origin === "projectPage") {
                  this.router.navigate(['/projecto']);
                } 
                else {
                  this.router.navigate(['/dashboard']);
                }
                
                this.dataService.clearEstimativaNavigationContext();
              }
              else
                this.router.navigate(['/dashboard']);

              //just to be sure that all ai references are removed from the form and local storage, in case some slipped through the DTO transformation
              this.removeALLAiReferences();
            }
            else {
              console.log("ERRO", data.message);
            }
          })
        }

      }
    });
  }

  openDialog() {
    var arrAll;
    this.arr1 = [];
    arrAll = this.atividades;

    // Construir claves tarea+subtarea para validar duplicados estrictos
    if (arrAll && arrAll.length != 0) {
      for (var i = 0; i < arrAll.length; i++) {
        this.arr1.push(`${arrAll[i].task}|||${arrAll[i].subTask}`);
      }
    }

    // Listas únicas de épicas e historias de usuario ya utilizadas
    const existingEpics = [...new Set(
      (this.atividades || [])
        .map((a: any) => a.epic)
        .filter((e: any) => e != null && e !== '')
    )];

    const existingUserStories = [...new Set(
      (this.atividades || [])
        .map((a: any) => a.userStory)
        .filter((u: any) => u != null && u !== '')
    )];

    // Prepare data to be passed to dialog component
    const data = {
      title: this.variables.addActivity,
      actionList: this.catalogTasks,
      subTasks: this.catalogSubTasks,
      existingEpics,
      existingUserStories,
      metodology: this.estimate.projectMetodology,
      estimateMode: this.estimate.estimateMode,
      profiles: this.profiles
    }
    // Open dialog
    let dialogRef = this.dialog.open(CatalogDialogComponent, {
      width: '700px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const newKey = `${result.data.task}|||${result.data.subTask}`;
        if (this.arr1.includes(newKey)) {
          this._snackBar.open(this.variables.snackBarErrorAddActivity);
        }
        else {
          this.atividades.push(result.data);
          this.table.renderRows();
        }

      }
    });
  }

  removeItem(activity: any, index: any) {

    const data = {
      message: this.variables.removeActivityMessage
    }
    //Open dialog
    let dialogRef = this.dialog.open(GenericDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.data) {
        if (isAiGeneratedItem(activity)) {
          this.removeAiGeneratedItemFromSessionStorage(activity);
        }

        this.atividades = this.atividades.filter((_: any, currentIndex: any) => currentIndex !== index);

        if (this.estimate?.subTasks) {
          this.estimate.subTasks = this.atividades;
        }

        this.infoBar.showSnackbar(this.variables.subtaskRemovedSuccessfully, ['successful-snackbar'], 4000);
      }
    })

  }

  private removeAiGeneratedItemFromSessionStorage(activity: any): void {
    const aiData = this.dataService.getAiGeneratedActionItems();
    if (!aiData?.actionItems || !Array.isArray(aiData.actionItems)) {
      return;
    }

    const updatedActionItems = aiData.actionItems.map((storedItem: any) =>
      this.isSameActionItem(storedItem, activity) ? { ...activity } : storedItem
    );

    this.dataService.setAiGeneratedActionItems({
      ...aiData,
      actionItems: updatedActionItems
    });
  }

  private isSameActionItem(a: any, b: any): boolean {
    return a?.task === b?.task
      && a?.subTask === b?.subTask
      && (a?.epic || '') === (b?.epic || '')
      && (a?.userStory || '') === (b?.userStory || '');
  }

  editItem(element: any, index: number) {

    var arrAll;
    this.arr1 = [];
    arrAll = this.atividades;

    if (arrAll && arrAll.length != 0) {
      for (var i = 0; i < arrAll.length; i++) {
        const activity = arrAll[i];
        // Excluir la actividad que se está editando para poder mantener su par tarea+subtarea
        if (i !== index) {
          this.arr1.push(`${activity.task}|||${activity.subTask}`);
        }
      }
    }

    // Prepare data to be passed to dialog component
    const data = {
      title: this.variables.changeActivity,
      actionList: this.catalogTasks,
      element: element,
      //region: this.catalogo.region,
      subTasks: this.catalogSubTasks,
      metodology: this.estimate.projectMetodology,
      type: 'EDIT_OTHER',
      profiles: this.profiles
    }

    // Open dialog
    let dialogRef = this.dialog.open(CatalogDialogComponent, {
      width: '700px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        const newKey = `${result.data.task}|||${result.data.subTask}`;
        if (this.arr1.includes(newKey)) {
          this._snackBar.open(this.variables.snackBarErrorEditActivity);
        }
        else {
          const editedActivity = this.atividades[index];
          if (editedActivity) {

            // If the subtask was AI-generated, update the local storage data for aiActionItem with the new values
            // by idenifying the record with the previous values before replacing themwith new ones
            this.updateAiGeneratedItemInSessionStorage(editedActivity,result.data.subTask);

            editedActivity.subTask = result.data.subTask;
            editedActivity.task = result.data.task;
            editedActivity.complexityLevel = result.data.complexityLevel;
            editedActivity.itemCount = result.data.itemCount;
            editedActivity.complexity = result.data.complexity;
            //e.gcm = result.data.gcm
            editedActivity.gcm = 0
            editedActivity.profileId = result.data.profileId || null;
          }

          this.infoBar.showSnackbar(this.variables.subtaskEditedSuccessfully, ['successful-snackbar'], 4000);
        }
      }
    });

  }

  private updateAiGeneratedItemInSessionStorage(previous: any, updated: any): void {
    const aiData = this.dataService.getAiGeneratedActionItems();
    if (!aiData?.actionItems || !Array.isArray(aiData.actionItems)) {
      return;
    }

    const updatedActionItems = aiData.actionItems.map((storedItem: any) =>
      this.isSameActionItem(storedItem, previous) ? { ...updated } : storedItem
    );

    this.dataService.setAiGeneratedActionItems({
      ...aiData,
      actionItems: updatedActionItems
    });
  }

  editItemAgile(element: any) {
    // Listas únicas de épicas e historias de usuario ya utilizadas
    const existingEpics = [...new Set(
      (this.atividades || [])
        .map((a: any) => a.epic)
        .filter((e: any) => e != null && e !== '')
    )];

    const existingUserStories = [...new Set(
      (this.atividades || [])
        .map((a: any) => a.userStory)
        .filter((u: any) => u != null && u !== '')
    )];

    const data = {
      title: this.variables.changeActivity,
      actionList: this.catalogTasks,
      subTasks: this.catalogSubTasks,
      element: element,
      metodology: this.estimate.projectMetodology,
      existingEpics,
      existingUserStories,
      estimateMode: this.estimate.estimateMode,
      type: "EDIT_AGILE",
      profiles: this.profiles
    }


    let dialogRef = this.dialog.open(CatalogDialogComponent, {
      width: '700px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.atividades.forEach((e: any) => {
          if (e.task === element.task && e.subTask === element.subTask) {
            e.epic = result.data.epic;
            e.userStory = result.data.userStory;
            e.subTask = result.data.subTask;
            e.task = result.data.task;
            e.mode = result.data.mode;
            e.complexityLevel = result.data.complexityLevel;
            e.complexity = result.data.complexity;
            e.tshirtScaleLevel = result.data.tshirtScaleLevel;
            e.tshirtScaleEffort = result.data.tshirtScaleEffort;
            e.itemCount = result.data.itemCount;
            //e.gcm = result.data.gcm
            e.gcm = 0
            e.profileId = result.data.profileId || null;
          }
        });

        this.infoBar.showSnackbar(this.variables.subtaskEditedSuccessfully, ['successful-snackbar'], 4000);
      }
    })
  }

  getProfileCenter(profileId: string): string {
    if (!profileId) return '-';
    const profile = this.profiles.find(p => p.id === profileId);
    return profile ? `${profile.center}` : '-';
  }

  getProfileName(profileId: string): string {
    if (!profileId) return '-';
    const profile = this.profiles.find(p => p.id === profileId);
    return profile ? profile.name : '-';
  }

  getProfileCostPerHour(profileId: string): string {
    if (!profileId) return '-';
    const profile = this.profiles.find(p => p.id === profileId);
    return profile ? `${profile.costPerHour}(€/h)` : '-';
  }

  removeALLAiReferences() {

    this.removeAiGeneratedSubTasks()
    this.removeAiGeneratedMacrosFromForm();

    this.clearAiData();

    this.dataService.setShowAiMacroWarning(false);
    this.modifiedSubTasks = [];
  }

  private removeAiGeneratedMacrosFromForm(): void {
    const removeAiItems = (items: any[]): any[] => {
      if (!Array.isArray(items)) {
        return items;
      }

      return items.filter((item: any) => !isAiGeneratedItem(item));
    };


    if (this.estimate && Array.isArray(this.estimate.macroActivities))
      this.estimate.macroActivities = this.estimate.macroActivities.map((group: any) => {
        if (Array.isArray(group?.macroActivities)) {
          group.macroActivities = group.macroActivities.map((macro: any) =>
            isAiGeneratedItem(macro) ? { ...macro, aiGenerated: false } : macro
          );
        }
        return group;
      });

  }

  private removeAiGeneratedSubTasks(): void {
    const removeAiItems = (items: any[]): any[] => {
      if (!Array.isArray(items)) {
        return items;
      }

      return items.filter((item: any) => !isAiGeneratedItem(item));
    };

    this.atividades = removeAiItems(this.atividades);
    this.modifiedSubTasks = removeAiItems(this.modifiedSubTasks);

    if (this.estimate && Array.isArray(this.estimate.subTasks)) {
      this.estimate.subTasks = removeAiItems(this.estimate.subTasks);
    }

    const componentAsAny = this as any;
    if (Array.isArray(componentAsAny.modifiedAiSubTasks)) {
      componentAsAny.modifiedAiSubTasks = removeAiItems(componentAsAny.modifiedAiSubTasks);
    }
  }

}

